<template>
  <v-circle :config="config" />
</template>

<script>
export default {
  name: 'BasicCircle',
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  }
}
</script>